
import { defineComponent, PropType } from 'vue';
import { TileTileModel } from '@/types/B2BcontentServerContract';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';

export default defineComponent({
    name: 'TileTile',
    components: {
        MediaHandler,
        CMSLinkHandler,
    },
    props: {
        content: {
            type: Object as PropType<TileTileModel>,
            required: true,
        },
    },
    setup() {
        return {
            aspectRatio: {
                'xs, sm, md': 16 / 9,
                default: 20 / 9,
            },
        };
    },
});
